<template>
  <div class="">
    <section class="d-flex flex-column h-full">
      <!-- <div class="fixed-header w-full"> -->
      <TopAppBar
        :leftBtnMode="leftBtnMode"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :leftBtnMethod="leftBtnMethod"
        :rightBtnMethod="rightBtnMethod"
        staticMode="true"
      ></TopAppBar>
      <TopAppBarDrawer
      :isDrawerOpen="isDrawerOpen"
      @closeDrawer="closeDrawer"
    ></TopAppBarDrawer>
    </section>
    <div id="tab1">
      <div class="bg-gray pdt-16 pdl-8 pdr-8 bg-height">
        <div class="pdl-16 pdr-16 pdb-24">
          <div
            class="t-subtitle5 t-color-title t-center l-spacing54 mgb-4 font-m"
          >
            {{ $t("1827", { str: lastName + " " + firstName }) }}
          </div>
          <div class="t-body3 t-center l-spacing42 t-color-title">
            {{ $t("1828") }}
          </div>
        </div>
        <div class="d-flex two-column">
          <div
            class="pdl-8 pdr-8"
            @click.prevent="$router.push('/bookmarked-lesson')"
          >
            <div
              class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-8"
            >
              <div class="d-flex justify-content-end">
                <div class="count position-relative">
                  <span class="position-absolute count-back bg-custom1"></span>
                  <div class="t-headline7 t-center l-spacing6 t-color-custom1">
                    {{ portFolioList ? portFolioList.lessonBookmarkCount : "" }}
                  </div>
                </div>
              </div>
              <div class="pdl-8">
                <img
                  src="images/portfolio/book-outline.svg"
                  alt=""
                  class="max-w-28 mgb-8 mgt-16"
                />
              </div>
              <div class="t-body3 t-color-title mgt-4 pdb-8 pdl-8  t-body3-fontsize">
                {{ $t("1829") }}
              </div>
            </div>
          </div>
          <div
            class="pdl-8 pdr-8"
            @click.prevent="$router.push('/bookmarked-mission')"
          >
            <div
              class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-8"
            >
              <div class="d-flex justify-content-end">
                <div class="count position-relative">
                  <span class="position-absolute count-back bg-custom2"></span>
                  <div class="t-headline7 t-center l-spacing6 t-color-custom2">
                    {{
                      portFolioList ? portFolioList.missionBookmarkCount : ""
                    }}
                  </div>
                </div>
              </div>
              <div class="pdl-8">
                <img
                  src="images/portfolio/notebook-outline.svg"
                  alt=""
                  class="max-w-28 mgb-8 mgt-16"
                />
              </div>
              <div class="t-body3 t-color-title mgt-4 pdb-8 t-body3-fontsize">
                {{ $t("1830") }}
              </div>
            </div>
          </div>
          <div
            class="pdl-8 pdr-8"
            @click.prevent="$router.push('/liked-lesson')"
          >
            <div
              class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-8"
            >
              <div class="d-flex justify-content-end">
                <div class="count position-relative">
                  <span class="position-absolute count-back bg-custom3"></span>
                  <div class="t-headline7 t-center l-spacing6 t-color-custom3">
                    {{ portFolioList ? portFolioList.lessonLikeCount : "" }}
                  </div>
                </div>
              </div>
              <div class="pdl-8">
                <img
                  src="images/portfolio/heart-box-outline.svg"
                  alt=""
                  class="max-w-28 mgb-8 mgt-16"
                />
              </div>
              <div class="t-body3 t-color-title mgt-4 pdb-8  t-body3-fontsize">
                {{ $t("1831") }}
              </div>
            </div>
          </div>
          <div
            class="pdl-8 pdr-8"
            @click.prevent="$router.push('/social-lesson')"
          >
            <div
              class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-8"
            >
              <div class="d-flex justify-content-end">
                <div class="count position-relative">
                  <span class="position-absolute count-back bg-custom4"></span>
                  <div class="t-headline7 t-center l-spacing6 t-color-custom4">
                    {{ portFolioList ? portFolioList.articleLikeCount : "" }}
                  </div>
                </div>
              </div>
              <div class="pdl-8">
                <img
                  src="images/portfolio/tag-heart-outline.svg"
                  alt=""
                  class="max-w-28 mgb-8 mgt-16"
                />
              </div>
              <div class="t-body3 t-color-title mgt-4 pdb-8 t-body3-fontsize">
                {{ $t("1832") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="divider"></div> -->
      <!-- <div
        class="mgt-30 mgb-1 d-flex flex-row justify-content-between align-items-baseline pdl-16 pdr-16"
        v-if="recommendedList && recommendedList.length > 0"
      >
        <p class="mgb-8 mgt-1 t-subtitle1 l-spacing6">{{ $t("1833") }}</p>
        <p
          v-if="recommendedListLength > 5"
          class="mgb-8 mgt-1 t-body2 t-color-red1 l-spacing98"
          @click.prevent="redirectToRecomendedList"
        >
          {{ $t("1834") }}
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import portfolioApi from "@/api/portfolioApi.js";
import mainApi from "@/api/mainApi.js";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

export default {
  name: "Portfolio",
  data() {
    return {
      // title
      portFolioList: null,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        translate: 0,
        autoHeight: false,
      },
      memberData: null,
      firstName: null,
      lastName: null,
      recommendedList: null,
      recommendedListLength: 0,
      
      isOpenDrawer: false,
    };
  },
  components: {
    swiper,
    swiperSlide,
    TopAppBar,
    TopAppBarDrawer,
  },

  mixins: [topAppBarMixin],

  computed: {
    // swiper define
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  mounted() {
    this.leftBtnMode = "menu";
    this.leftBtnMethod = this.openDrawer;
    this.fetchData();
  },
  methods: {
    fetchData() {
      mainApi
        .fetMember()
        .then((response) => {
          this.memberData = response.data.data;
          this.firstName = this.memberData.member
            ? this.memberData.member.name.first
            : "";
          this.lastName = this.memberData.member
            ? this.memberData.member.name.last
            : "";
          this.profileImage = this.memberData.member
            ? this.memberData.member.profile.resourceUri
            : "";

          //this.$hideLoading();
        })
        .catch((err) => {
          responseData = err.response.data.meta;
          this.$error({ content: responseData.errMsg }).then(() => {});
        });
      // 채팅 룸 정보(get chatting room list)
      portfolioApi
        .portfolioList()
        .then((response) => {
          this.portFolioList = response.data.data;
          this.recommendedList = this.portFolioList.purchaseOnlineDegreeDtos
          //console.log('recommendedList',this.recommendedList)
          // let list = response.data.data.content;

          // if (!list.length) {
          //     this.isNoData = true
          // }
        })
        .catch((err) => {});
      let params = {
        size: 5,
      };
      // mainApi
      //   .fetchRecommendedList(params)
      //   .then((response) => {
      //     this.recommendedList = response.data.data.content;
      //     if (response.data.data.content) {
      //       this.recommendedListLength = response.data.data.totalElements;
      //     }
      //   })
      //   .catch((err) => {
      //     responseData = err.response.data.meta;
      //     this.$error({ content: responseData.errMsg }).then(() => {});
      //   });
    },

    redirectToCourseDetail(id) {
      this.$router.push("/degree/" + id + "?type=ListNew");
    },
    redirectToRecomendedList() {
      localStorage.setItem("portfolio", "backtoPortfolio");
      this.$router.push("/degree?type=ListRecommened");
    },
    openDrawer() {
      this.isDrawerOpen = true;
    },
    closeDrawer() {
      this.isDrawerOpen = false;
    },
  },
};
</script>
<style scoped>
.bg-height{
  height: calc(100vh - 56px);
}
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}
.tabs .tab {
  width: 50%;
}
.badge-chip {
  bottom: 0;
  right: 0;
  border-radius: 12px;
}
.two-column {
  flex-wrap: wrap;
}
.two-column > div {
  flex: 0 0 50%;
}
.count {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
}

span.swiperImageIndicator {
  right: 8px;
  bottom: 8px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.18);
  border-radius: 30px;
}
.swiperSlideWrapper {
  width: 70%;
}
.swiperPercentWrapper {
  line-height: 0.5;
}
.swiperImageHolder img {
  max-height: 130px;
  object-fit: cover;
}
.swiperTitle {
  font-size: 16px;
}
.swiperSubTitle {
  font-size: 14px;
}
.cardInner {
  border-bottom: 1px solid rgba(172, 180, 190, 0.7);
}
.cardInner:last-child {
  border-bottom: none;
}
.swiper-slide {
  width: 232px;
}
.leaf-wrapper {
  position: absolute;
  left: 60px;
  top: -22px;
}
@media (min-width: 768px) {
  .bubble-image {
    width: 300px;
  }

  .swiperSlideWrapper {
    width: 350px;
  }
  .swiper-slide {
    width: auto;
  }
  .swiperImageHolder img {
    min-height: 235px;
    object-fit: cover;
  }
}
.line-through:after {
  position: absolute;
  content: "";
  width: 100%;
  height: 1px;
  background: red;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.t-body3-fontsize {
  font-size: 0.840rem !important;
}
/* #80808012 */
</style>